<div #buttonRef class='ButtonSelect'>
  <app-button
    [Click]='toggleItems'
    [icon]='buttonIcon'
    [size]='buttonProperties.size'
    [style]="'filled'"
    [text]='buttonProperties.text'
    color='blue'></app-button>
  <div
    #itemsElement
    *ngIf='showItems && items && items.length > 0'
    class='ButtonSelect-items'>
    <ul>
      <ng-template #recursiveList let-items>
        <li
          *ngFor='let item of items'
          [ngClass]='{ parent: item.children && item.children.length > 0 }'
          on-mouseover='onMouseOverElement($event, item)'>
          <div
            [popoverAnimation]='true'
            [popoverDisabled]='false'
            [popoverOnHover]='true'
            [popover]='item.popoverText || null'
            class='ButtonSelect-items-item d-flex flex-row'
            popoverPlacement='top-right'>
            <div
              *ngIf='item.dialogContent'
              class='ButtonSelect-items-item-dialog flex-grow-0'>
              <app-svg-renderer
                (click)='openDialog(item)'
                [svg]="'Yellow Plane'"></app-svg-renderer>
            </div>
            <a
              (click)='itemClicked(item)'
              *ngIf="item.type && item.type === 'link'"
              [routerLink]='item.value'
              class='ButtonSelect-items-item-label flex-grow-1'
            >{{ item.label }}</a
            >
            <span
              (click)='itemClicked(item)'
              *ngIf="!item.type || item.type === 'normal'"
              class='ButtonSelect-items-item-label flex-grow-1'
            >{{ item.label }}</span
            >
            <div
              *ngIf='item.children && item.children.length > 0'
              class='ButtonSelect-items-arrow'></div>
          </div>
          <div
            *ngIf='item.children && item.children.length > 0'
            class='ButtonSelect-items wrapper'>
            <ul>
              <ng-container
                *ngTemplateOutlet='
                  recursiveList;
                  context: { $implicit: item.children }
                '></ng-container>
            </ul>
          </div>
        </li>
      </ng-template>
      <ng-container
        *ngTemplateOutlet='
          recursiveList;
          context: { $implicit: items }
        '></ng-container>
    </ul>
  </div>
</div>
